import { render, staticRenderFns } from "./airCleanAlarmDetail.vue?vue&type=template&id=777caef0&scoped=true"
import script from "./airCleanAlarmDetail.vue?vue&type=script&lang=js"
export * from "./airCleanAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./airCleanAlarmDetail.vue?vue&type=style&index=0&id=777caef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777caef0",
  null
  
)

export default component.exports